// extracted by mini-css-extract-plugin
module.exports = {"views_counter__container":"styles_views_counter__container__2Vh01","views_counter__icon":"styles_views_counter__icon__31EUf"};